const rankings = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店监控画面流出', heat: '🔥 爆', views: '126万' },
  { rank: 2, title: '知名网红直播带货翻车，产品质检报告造假被揭穿', heat: '🔥 热', views: '98万' },
  { rank: 3, title: '某综艺节目导演组潜规则聊天记录曝光', heat: '📈 升', views: '87万' },
  { rank: 4, title: '当红女星前经纪人揭秘：合约背后的霸王条款', heat: '📈 升', views: '74万' },
  { rank: 5, title: '音乐节主办方跑路，多位艺人演出费被拖欠', heat: '🆕 新', views: '61万' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          黑料榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          本周最火爆的黑料排行，热度决定一切
        </p>
        <div className="space-y-3">
          {rankings.map((r) => (
            <a
              key={r.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <span className={`w-9 h-9 flex items-center justify-center rounded-xl font-heading text-lg font-bold flex-shrink-0 ${
                r.rank === 1 ? 'bg-primary-500 text-background-50' :
                r.rank === 2 ? 'bg-primary-400 text-background-50' :
                r.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-secondary-300 text-foreground-700'
              }`}>
                {r.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 truncate group-hover:text-primary-700 transition-colors">
                  {r.title}
                </p>
              </div>
              <span className="text-xs whitespace-nowrap text-foreground-500 flex-shrink-0">{r.heat}</span>
              <span className="text-xs whitespace-nowrap text-foreground-400 flex-shrink-0 hidden sm:inline">{r.views}阅读</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}